// Sweet Alerts Texts
export const txtSA = {
  title: (id, entity) => (!id ? `درخواست ایجاد ${entity}` : `درخواست ویرایش اطلاعات`),
  description: (id, entity) =>
    !id
      ? ` درخواست ساخت ${entity} با موفقیت ثبت شد و کارشناسان ما در حال بررسی آن
  هستند. پس از تایید اطلاعات شما توسط کارشناسان، وضعیت درخواست شما به حالت
  فعال در خواهد آمد .`
      : ` درخواست ویرایش اطلاعات ${entity} با موفقیت ثبت شد و کارشناسان ما در حال بررسی آن
  هستند. پس از تایید اطلاعات شما توسط کارشناسان، وضعیت درخواست شما به حالت
  فعال در خواهد آمد .`,
  btn: 'تایید',
  setOrgPerUser: {
    title: 'درخواست همکاری',
    description: `درخواست شما برای همکاری با سازمان موردنظر با موفقیت ارسال شد.
    کارشناسان سازمان در حال بررسی آن هستند و پس از تایید، وضعیت شما به
    حالت فعال در خواهد آمد.`,
    btn: 'تایید',
  },
};

// React Toastify Texts
export const txtRT = {
  form: {
    noDiff: 'بدون تغییر در فرم اطلاعات ارسال نخواهد شد.',
    noFull: 'هنوز فرم را به طور کامل پر نکرده اید',
    preRequisiteImportant: 'برای افزودن پیشنیاز به دوره، لطفا یک درس انتخاب کنید',
  },
  table: {
    for_review: 'درخواست شما با موفقت ثبت شده است. متخصصان ما در حال بررسی هستند.',
    setAccepted: 'با موفقیت تائید شد',
    setRejected: 'با موفقیت رد شد',
  },
  dropdown: {
    radio: `درخواست شما برای همکاری، توسط سازمان موردنظر  در حال بررسی است.`,
  },
  generic: {
    failed: `خطایی رخ داده است`,
  },
};

// React Helmet Texts
export const txtRH = {
  createInstructor: {
    title: 'استاد شوید',
  },
  createOrganization: {
    title: 'ایجاد سازمان',
  },
  createCourse: {
    title: id => (id ? 'ویرایش اطلاعات' : 'ایجاد دوره'),
  },
  userCourses: {
    title: 'دوره‌های من',
  },
  userInstructors: {
    title: 'صفحه من',
  },
  userOrganizations: {
    title: 'سازمان‌های من',
  },
};

// React Hook Form Texts
export const txtRHF = {
  error: {
    required: 'این فیلد اجباری است',
    minLength: min => ` لطفا بیش از ${min} کاراکتر وارد کنید`,
  },
};

// Button Text
export const txtBtn = {
  create: (entity = '') => `ایجاد ${entity}`,
  update: (entity = '') => `تغییر اطلاعات ${entity}`,
};

// Table Head context
export const txtTable = {
  counter: '#',
  caption: 'عنوان',
  status: 'وضعیت',
};

// Pages content
export const txtPage = {
  dashboard: {
    title: 'درس‌آپ',
    description: `در درس‌آپ می‌توانید به دو صورت مؤسسه یا استاد فعالیت کنید. در
  هر کدام از زمینه‌ها امکاناتی بی‌نظیر برای مدیریت، سیاست های
  درآمدزایی خود و خیلی از موارد دیگر را می‌توانید داشته باشید.
  بیاید همین الان شروع کنیم.ابتدا زمینه فعالیت خود را انتخاب
  کنید.`,
    boxes: {
      createInstructor: 'میخواهم مدرس شوم',
      createOrganization: 'میخواهم سازمان ایجاد کنم',
      createCourse: 'میخواهم دوره ایجاد کنم',
    },
  },
  createCourse: {
    tabLinks: {
      marketing: 'جامعه هدف و بازاریابی',
      intro: 'اطلاعات معرفی دوره',
      pricingPolicy: ' سیاست قیمت گذاری',
    },
    btn: {
      temp: 'ثبت موقت جهت تکمیل در آینده',
      stable: ' ثبت دایمی و درخواست بررسی',
    },
    form: {
      label: {
        whatLearns: 'دانشجو در دوره شما چی یاد میگیره؟',
        links: 'لینک دوره های پیشنیاز این دروه را اینجا وارد کن',
        selectPreRequisites: 'دوره های پیش نیاز این دروه را انتخاب کنید( اگر پیش نیاز نداره خالی رهاش کن )',
        stateCourse: 'سطح دوره',
        language: 'زبان محتوای دوره',
        title: 'عنوان دوره',
        smallDesc: 'توضیحات کوتاه دوره',
        longDesc: 'توضیحات بلند و کامل دوره',
        priceRange: 'ردیف قیمت پیشنهادی',
        offs: 'تخفیف',
        errorExistItem: 'این دوره قبلا انتخاب شده است',
        courseTeacher: 'استاد دوره',
        file: (type, size) => `انتخاب ${type} (حداکثر ${size} مگابایت)`,
      },
    },
  },
  createInstructor: {
    form: {
      label: {
        file: 'آپلود عکس پروفایل',
        name: ' نام نمایشی',
        bio: 'بیوگرافی',
      },
    },
  },
  createOrganization: {
    form: {
      label: {
        name: ' نام سازمان',
        description: ' معرفی سازمان',
        logo: ' لوگو سازمان',
      },
    },
  },
  userCourses: {
    notCourses: {
      description: ` شما هنوز دوره‌‌‌ای را ایجاد نکرده اید. با ایجاد دوره، شما
      می‌توانید لیست دوره‌های ایجاد شده را در این صفحه مشاهده کنید.`,
    },
    courses: {},
  },
  CourseRunDemands: {
    notCourses: {
      description: `هنوز دوره‌ای برای سازمان شما تعریف نشده است
از طریق لینک زیر اولین دوره‌ی سازمان را ایجاد کنید`,
    },
  },
  userOrganizations: {
    notOrganizations: {
      description: ` شما هنوز سازمانی را ایجاد نکرده اید. با ایجاد سازمان، شما
      می‌توانید لیست سازمان‌های ایجاد شده را در این صفحه مشاهده کنید.`,
    },
  },
};
